// handle everything about Content-security policy here because AWS infra has strict limit on field length
import { Environment } from '~/core';

function setFrameAncestorsToReq() {
  const request = useRequestEvent();
  const rixos = useRuntimeConfig().public.rixosPartnerLink;
  const contentful = process.server ? 'https://app.contentful.com' : '';

  request?.node.res.setHeader(
    'Content-Security-Policy',
    `frame-ancestors self ${contentful} ${rixos};`,
  );
}

export default defineNuxtPlugin(() => {
  setFrameAncestorsToReq();
});
